import { Component } from '@angular/core';

@Component({
  selector: 'app-default-page',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
})
export class DefaultComponent {
  constructor() {}

  closeMobileMenu() {
    document.body.classList.remove('mobile-menu-open');
    document.getElementsByTagName('html')[0].classList.remove('mobile-menu-open');
    document.body.parentElement.removeAttribute('style');
  }
}
